import * as React from "react";
import s from './modal.module.scss';
import { createPortal } from "react-dom";

export default function Modal(props) {
  return createPortal(
    props.children,
    document.getElementById("modal-root")
  )
};